<template>
  <div class="callout warning mt-2 p-2 text-sm">
    <div class="flex items-start gap-2">
      <fluent-icon class="mt-0.5 flex-shrink-0" icon="warning" :size="16" />
      <div>
        <div class="font-semibold">
          {{
            $t(
              'CHATLYN_CONTACT_LISTS.SEND_MESSAGE_MODAL.TOTAL_COUNT_WARNING.TITLE'
            )
          }}
        </div>
        <div class="text-xs opacity-75">
          {{
            $t(
              'CHATLYN_CONTACT_LISTS.SEND_MESSAGE_MODAL.TOTAL_COUNT_WARNING.MESSAGE'
            )
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalCountWarning',
};
</script>

<style></style>
